var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index-page",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "preloadResource",
    style: {
      background: !_vm.isMobile ? `
      url(${require('@images/p1-bg.jpg')}),
      url(${require('@images/p2-img-1.png')}),
      url(${require('@images/p2-img-2.png')}),
      url(${require('@images/p3-img-1.jpg')}),
      url(${require('@images/p3-img-2.jpg')}),
      url(${require('@images/p4-img-1.jpg')}),
      url(${require('@images/p5-img.png')}),
      url(${require('@images/Virtual Card p.png')}),
      url(${require('@images/Physical Card p.png')}),
      url(${require('@images/p4-img-2.jpg')}),
      url(${require('@images/p4-img-3.jpg')}),
      url(${require('@images/p4-img-4.jpg')}),
      url(${require('@images/p4-img-5.jpg')}),
      url(${require('@images/p4-img-6.jpg')}),
      ` : `
      url(${require('@images/wap_p1-bg.jpg')}),
      url(${require('@images/p2-img-1.png')}),
      url(${require('@images/p2-img-2.png')}),
      url(${require('@images/wap_p3-img-1.jpg')}),
      url(${require('@images/wap_p3-img-2.jpg')}),
      url(${require('@images/wap_p4-img-1.jpg')}),
      url(${require('@images/Virtual Card w p.png')}),
      url(${require('@images/Physical Card w p.png')}),
      url(${require('@images/p5-img.png')}),
      url(${require('@images/wap_p4-img-2.jpg')}),
      url(${require('@images/wap_p4-img-3.jpg')}),
      url(${require('@images/wap_p4-img-4.jpg')}),
      url(${require('@images/wap_p4-img-5.jpg')}),
      url(${require('@images/wap_p4-img-6.jpg')}),
      `
    }
  }, [!_vm.isMobile ? [_c('video', {
    attrs: {
      "preload": "auto",
      "muted": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "src": require('@images/Virtual Card.mp4')
    },
    domProps: {
      "muted": true
    }
  }), _c('video', {
    attrs: {
      "preload": "auto",
      "muted": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "src": require('@images/Physical Card.mp4')
    },
    domProps: {
      "muted": true
    }
  })] : [_c('video', {
    attrs: {
      "preload": "auto",
      "muted": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "src": require('@images/Virtual Card w.mp4')
    },
    domProps: {
      "muted": true
    }
  }), _c('video', {
    attrs: {
      "preload": "auto",
      "muted": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "src": require('@images/Physical Card w.mp4')
    },
    domProps: {
      "muted": true
    }
  })]], 2), _c('div', {
    staticClass: "index-head"
  }, [_c('m-head')], 1), _c('div', {
    staticClass: "index-main"
  }, [_c('div', {
    staticClass: "index-p1"
  }, [_c('div', {
    staticClass: "index-p1-main wrap"
  }, [_c('div', {
    staticClass: "index-p1__title wow fadeInLeft",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("YOUR USDT, YOUR VISA")) + " "), _c('br'), _c('i', [_vm._v(_vm._s(_vm.$lang("ZERO LIMITS")))])]), _c('div', {
    staticClass: "index-p1__sub wow fadeInLeft",
    attrs: {
      "data-wow-duration": "0.6s"
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("Get your own Web3-native VISA card, recharge with USDT, and spend online anywhere — instantly and securely.")) + " ")]), _c('div', {
    staticClass: "index-p1-btn wow fadeInLeft",
    attrs: {
      "data-wow-duration": "0.7s"
    }
  }, [_c('div', {
    staticClass: "index-p1-btn__title"
  }, [_vm._v(_vm._s(_vm.$lang("Claim From")))]), _c('div', {
    staticClass: "index-p1-btn-main"
  }, [_c('div', {
    staticClass: "index-p1-btn-item telegram",
    on: {
      "click": function ($event) {
        return _vm.onSkip('m_telegram');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon-telegram.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "index-p1-btn-item browser",
    on: {
      "click": function ($event) {
        return _vm.onSkip('m_browser');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon-browser.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "index-p1-btn-item line",
    on: {
      "click": function ($event) {
        return _vm.onSkip('m_line');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon-line.png'),
      "alt": ""
    }
  })])])])])]), _c('div', {
    staticClass: "index-p2",
    attrs: {
      "id": "About"
    }
  }, [_c('div', {
    staticClass: "index-p2-main wrap"
  }, [_c('div', {
    staticClass: "index-p__title wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("WHAT IS MPAY ?")) + " ")]), _c('div', {
    staticClass: "index-p__sub wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.6s"
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang(`MPay is the next-generation Web3 payment platform that empowers users worldwide with a USDT-backed VISA card, enabling seamless online spending across millions of merchants. With just a simple USDT top-up, users gain instant access to global e-commerce`)) + " ")]), _c('div', {
    staticClass: "index-p2-intro"
  }, [_c('div', {
    staticClass: "index-p2-item wow fadeInLeft",
    attrs: {
      "data-wow-duration": "0.8s"
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/p2-img-1.png'),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "index-p2-item-main xs"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Powered by crypto. Designed for real life.")) + " ")])]), _c('div', {
    staticClass: "index-p2-item wow fadeInRight",
    attrs: {
      "data-wow-duration": "0.8s"
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/p2-img-2.png'),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "index-p2-item-main"
  }, [_vm._v(" " + _vm._s(_vm.$lang("Backed by IsPay & Invested by Mason Labs, a leader in Web3 infrastructure investment.")) + " ")])])])])]), _c('div', {
    staticClass: "index-p3",
    attrs: {
      "id": "Card"
    }
  }, [_c('div', {
    staticClass: "index-p3-main"
  }, [_c('div', {
    staticClass: "index-p3-slide"
  }, [_c('div', {
    staticClass: "index-p3-slide-main",
    class: _vm.isMobile && 'wrap'
  }, [_vm.p3.p3TabSelect ? [_c('div', {
    staticClass: "index-p3__title",
    domProps: {
      "innerHTML": _vm._s(_vm.p3.p3TabSelect.title)
    }
  }), _c('div', {
    staticClass: "index-p3__tag"
  }, [_c('i', [_vm._v(_vm._s(_vm.p3.p3TabSelect.tag))])]), _c('div', {
    staticClass: "index-p3__sub"
  }, [_vm._v(_vm._s(_vm.p3.p3TabSelect.sub))]), _c('div', {
    staticClass: "index-p3__info"
  }, [_vm._v(_vm._s(_vm.p3.p3TabSelect.info))])] : _vm._e()], 2), _vm.p3.p3TabSelect && _vm.isVideoShow ? _c('div', {
    staticClass: "index-p3-video"
  }, [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.p3.p3TabSelect.type == _vm.p3.p3Tab[0].type,
      expression: "p3.p3TabSelect.type == p3.p3Tab[0].type"
    }],
    ref: "video0",
    attrs: {
      "autoplay": "",
      "muted": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "preload": "auto",
      "aria-hidden": "true",
      "poster": _vm.p3.p3Tab[0].poster
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.p3.p3Tab[0].img,
      "type": "video/mp4"
    }
  })]), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.p3.p3TabSelect.type == _vm.p3.p3Tab[1].type,
      expression: "p3.p3TabSelect.type == p3.p3Tab[1].type"
    }],
    ref: "video1",
    attrs: {
      "autoplay": "",
      "muted": "",
      "playsinline": "",
      "webkit-playsinline": "",
      "preload": "auto",
      "aria-hidden": "true",
      "poster": _vm.p3.p3Tab[1].poster
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.p3.p3Tab[1].img,
      "type": "video/mp4"
    }
  })])]) : _vm._e()]), _vm.p3.p3Tab.length ? _c('div', {
    staticClass: "index-tab"
  }, [_c('div', {
    staticClass: "index-tab-main"
  }, _vm._l(_vm.p3.p3Tab, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-tab-item",
      class: _vm.p3.p3TabSelect?.type === item.type && 'active',
      on: {
        "click": function ($event) {
          return _vm.onTabClick('p3', item, index);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.type))]), _vm.p3.p3TabSelect?.type === item.type && _vm.p3.isProgressShow ? _c('div', {
      staticClass: "index-tab-progress",
      style: {
        width: _vm.p3.progress + '%'
      }
    }) : _vm._e()]);
  }), 0)]) : _vm._e()])]), _c('div', {
    staticClass: "index-p4",
    attrs: {
      "id": "Scenarios"
    }
  }, [_c('div', {
    staticClass: "index-p4-main"
  }, [_c('div', {
    staticClass: "index-p4-slide"
  }, [_c('div', {
    staticClass: "index-p4-slide-main",
    class: _vm.isMobile && 'wrap'
  }, [_vm.p4.p4TabSelect ? [_c('div', {
    staticClass: "index-p4__title",
    domProps: {
      "innerHTML": _vm._s(_vm.p4.p4TabSelect.title)
    }
  }), _c('div', {
    staticClass: "index-p4__sub"
  }, [_vm._v(_vm._s(_vm.p4.p4TabSelect.sub))])] : _vm._e()], 2), _vm.p4.p4TabSelect ? [_c('img', {
    attrs: {
      "src": _vm.p4.p4TabSelect.img,
      "alt": ""
    }
  })] : _vm._e()], 2), _vm.p4.p4Tab.length ? _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll"
    }],
    ref: "p4ScrollRef",
    staticClass: "index-tab",
    class: _vm.isMobile && 'tab2'
  }, [_c('div', {
    staticClass: "index-tab-main"
  }, _vm._l(_vm.p4.p4Tab, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-tab-item",
      class: _vm.p4.p4TabSelect?.type === item.type && 'active',
      on: {
        "click": function ($event) {
          return _vm.onTabClick('p4', item, index);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.type))]), _vm.p4.p4TabSelect?.type === item.type && _vm.p4.isProgressShow ? _c('div', {
      staticClass: "index-tab-progress",
      style: {
        width: _vm.p4.progress + '%'
      }
    }) : _vm._e()]);
  }), 0)]) : _vm._e()])]), _c('div', {
    staticClass: "index-p5",
    attrs: {
      "id": "Safe"
    }
  }, [_c('div', {
    staticClass: "index-p5-main wrap"
  }, [_c('div', {
    staticClass: "index-p5-intro"
  }, [_c('div', {
    staticClass: "index-p5__title wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.2s"
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("YOUR USDT’S SAFE SPACE")) + " ")]), _c('div', {
    staticClass: "index-p5__sub wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.6s"
    }
  }, [_vm._v(" " + _vm._s(_vm.$lang("MPay is built with security at its core, combining the safety of non-custodial wallet integration with industry-grade payment infrastructure. Your funds remain in your control — MPay never holds your crypto. All card transactions are processed through licensed payment partners with robust fraud detection, data encryption, and real-time monitoring. By bridging Web3 assets with traditional payment rails securely, MPay ensures that every transaction is protected, private, and reliable.")) + " ")])]), _c('div', {
    staticClass: "index-p5-img wow bounceIn",
    attrs: {
      "data-wow-duration": "0.8s"
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/p5-img.jpg'),
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "index-p7",
    attrs: {
      "id": "General"
    }
  }, [_c('div', {
    staticClass: "index-p7-main wrap"
  }, [_c('div', {
    staticClass: "index-p7__title"
  }, [_vm._v(_vm._s(_vm.$lang("MPay – General Q&A")))]), _c('div', {
    staticClass: "index-p7-list"
  }, _vm._l(_vm.general, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-p7-item",
      on: {
        "click": () => item.isOpen = !item.isOpen
      }
    }, [_c('div', {
      staticClass: "index-p7-item__title"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "index-p7-expand"
    }, [_vm._l(2, function (_) {
      return !item.isOpen ? _c('span') : _vm._e();
    }), item.isOpen ? _c('span') : _vm._e()], 2)]), _c('div', {
      directives: [{
        name: "expand",
        rawName: "v-expand",
        value: item.isOpen,
        expression: "item.isOpen"
      }],
      staticClass: "index-p7-item__label",
      class: item.isOpen && 'isOpen',
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    })]);
  }), 0)])])]), _c('div', {
    staticClass: "index-footer"
  }, [_c('div', {
    staticClass: "index-footer-main wrap"
  }, [_c('div', {
    staticClass: "index-footer-logo",
    style: {
      background: `url(${require('@images/login-1.png')}) center/auto 100% no-repeat`
    }
  }), _c('div', {
    staticClass: "index-footer-share"
  }, _vm._l(_vm.share, function (item, index) {
    return _c('div', {
      staticClass: "index-footer-share-item",
      class: !item.type && (_vm.isMobile ? 'soon wap' : 'soon'),
      on: {
        "click": function ($event) {
          return _vm.onSkip(item.type);
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": item.icon
      }
    })], 1);
  }), 0)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };